
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["initEncrypt"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "8462a3300d0a35399983.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			